// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sidebar-content[data-v-4a145628]::-webkit-scrollbar{width:0}.sidebar-content[data-v-4a145628]::-webkit-scrollbar-thumb{background:transparent;border-radius:10px}.sidebar-content[data-v-4a145628]:hover::-webkit-scrollbar{position:absolute;width:0}.sidebar-content[data-v-4a145628]:hover::-webkit-scrollbar-thumb{background:#8b95a5}a[data-v-4a145628]:hover{-webkit-text-decoration:none;text-decoration:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
